import { makeAutoObservable } from 'mobx'
import {
  type IResponseFilters,
  type IResponseFilterOperator,
  type IFilterValue,
} from 'entities/Contacts/api/filterTypes'
import { type IFilterGroup } from 'widgets/FilterEditor/types/types'

import { getFilterGroups } from 'widgets/FilterEditor/utils'
import { FilterItemConfig } from 'widgets/FilterEditor/model/FilterItemConfig'

export class FiltersConfig<TValue = IFilterValue> {
  private _filtersMap = new Map<string, FilterItemConfig<TValue>>()
  private _customFiltersMap = new Map<string, FilterItemConfig<TValue>>()
  private _operatorsMap = new Map<string, IResponseFilterOperator[]>()
  private _filterGroups = new Array<IFilterGroup>()

  constructor() {
    makeAutoObservable(this)
  }

  get filterGroups() {
    return this._filterGroups
  }

  populate({ filters, custom_filters, operators }: Partial<IResponseFilters<TValue>>) {
    filters?.forEach((filter) => {
      // TODO: remove this 'if' logic after update in backend
      if (filter.key === 'automation_log_steps.executed_at') {
        const dateToday = new Date()
        const date30DaysAgo = new Date(dateToday.getTime() - 30 * 24 * 60 * 60 * 1000)

        filter.minDate = date30DaysAgo
        filter.maxDate = dateToday
      }
      this._filtersMap.set(filter.key, new FilterItemConfig(filter))
    })

    custom_filters?.forEach((filter) => {
      this._customFiltersMap.set(filter.key, new FilterItemConfig(filter))
    })

    Object.entries(operators ?? {}).forEach(([key, operator]) =>
      this._operatorsMap.set(key, operator)
    )

    this._filterGroups = getFilterGroups<TValue>(...(filters ?? []), ...(custom_filters ?? []))
  }

  getFilter(key: string) {
    return this._filtersMap.get(key) ?? null
  }

  getCustomFilter(key: string) {
    return this._customFiltersMap.get(key) ?? null
  }

  getAnyFilter(key: string) {
    return this._filtersMap.get(key) ?? this._customFiltersMap.get(key) ?? null
  }

  getOperators(type: string) {
    return this._operatorsMap.get(type) ?? null
  }
}
